import React from 'react'
import { Box } from '@mui/material'
import { useUserType } from '../../../../common/hooks/useUserType'
import { PatientDetails } from './PatientDetails'
import { PatientEeszt } from './PatientEeszt'
import { PatientDoctors } from '../../../patient/PatientDoctors/PatientDoctors'
import { useEesztTokenState } from '../../../../common/hooks/eeszt/useEesztTokenState'
import { useTranslation } from '../../../../common/hooks/helper/useTranslation'
import { EmptyState } from '../../../../common/components/EmptyState'
import { useParams } from 'react-router-dom'
import { UserType } from '../../../../models/graphqlTypes'
import { TreatmentSelector } from '../../Treatments/components/TreatmentSelector'
import { GetTreatmentPanelData } from '../../Treatments/components/GetTreatmentPanelData'
import {
  DoctorPatientProfile,
  DoctorPatientRouteParams,
} from '../types/doctorPatients.types'
import { PatientSurveys } from './PatientSurveys'
import { PatientReferrals } from './PatientReferrals'

type Props = {
  activeTabIndex: number
  patientProfile: DoctorPatientProfile
}

export const PatientPanel: React.FC<React.PropsWithChildren<Props>> = ({
  activeTabIndex,
  patientProfile,
}) => {
  const { t } = useTranslation()
  const { patientId, treatmentId } = useParams<DoctorPatientRouteParams>()
  const userType = useUserType()

  const isEesztTokenValid = useEesztTokenState()

  const loginToEesztMessage = (
    <Box
      maxWidth={1280}
      height="100%"
      justifyContent="center"
      alignItems="center"
      display="flex"
    >
      {userType === UserType.Doctor && (
        <EmptyState
          title={t('eeszt:notLoggedInTitle')}
          description={t('eeszt:notLoggedInDoctorMessage')}
        />
      )}
      {userType === UserType.Assistant && (
        <EmptyState
          title={t('eeszt:underConstruction')}
          description={t('eeszt:notAvailableForAssistants')}
        />
      )}
    </Box>
  )

  return (
    <Box overflow="auto" height="100%" width="100%">
      {activeTabIndex === 0 && (
        <>
          {!treatmentId && patientProfile && (
            <TreatmentSelector patientId={patientId} />
          )}
          {treatmentId && (
            <GetTreatmentPanelData patientProfile={patientProfile} />
          )}
        </>
      )}
      {activeTabIndex === 1 && <PatientDetails />}
      {activeTabIndex === 2 && <PatientDoctors patientId={patientProfile.id} />}
      {activeTabIndex === 3 && (
        <PatientReferrals patientProfile={patientProfile} />
      )}
      {activeTabIndex === 5 && (
        <>
          {isEesztTokenValid && (
            <Box width="100%" maxWidth={1280} p={2}>
              <PatientEeszt patientId={patientProfile.id} />
            </Box>
          )}
          {!isEesztTokenValid && <>{loginToEesztMessage}</>}
        </>
      )}

      {activeTabIndex === 6 && <PatientSurveys />}
    </Box>
  )
}
